// Meeting-Markierungen in der Historie: gestrichelte Senkrechte plus Dreieck auf
// der Achse. Datumslabels nur, wenn höchstens sieben Meetings sichtbar sind —
// darüber kollidieren sie.

import { PALETTE } from "../../palette";
import { localDayShort } from "../../format";
import type { G, Model } from "../model";

const MAX_LABELS = 7;

export function drawMeetings(g: G, model: Model, lang: string): void {
    const { plotTop, axisY } = model.layout;
    const xs = model.visMeetings;

    g.selectAll("line")
        .data(xs)
        .join("line")
        .attr("x1", (d) => model.x(d))
        .attr("x2", (d) => model.x(d))
        .attr("y1", plotTop)
        .attr("y2", axisY)
        .attr("stroke", PALETTE.inkFaint)
        .attr("stroke-width", 0.8)
        .attr("stroke-dasharray", "2 4");

    g.selectAll("path")
        .data(xs)
        .join("path")
        .attr("d", (d) => {
            const px = model.x(d);
            return "M" + (px - 4) + " " + axisY + "L" + (px + 4) + " " + axisY + "L" + px + " " + (axisY - 6) + "Z";
        })
        .attr("fill", PALETTE.inkFaint);

    g.selectAll("text")
        .data(xs.length <= MAX_LABELS ? xs : [])
        .join("text")
        .attr("x", (d) => model.x(d))
        .attr("y", axisY + 34)
        .attr("text-anchor", "middle")
        .attr("font-size", 10)
        .attr("fill", PALETTE.inkFaint)
        .text((d) => localDayShort(d, lang));
}
